import request from '@/utils/request';

/**
 * 当前在线客服供应商（免登录）
 * GET /liyuan-user/support/livechat → { providerId, provider }
 */
export function getSupportLiveChat() {
  return request.get('/liyuan-user/support/livechat');
}
